import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n/config';
import { ThemeProvider } from './contexts/ThemeContext';

// ============================================================================
// SERVICE WORKER KILL-SWITCH
// We previously registered a Service Worker, but it caused stale cache issues
// (users seeing old unstyled version on first load until they refreshed).
// We now actively UNREGISTER any existing Service Worker and clear all caches
// the next time a visitor loads the app, ensuring everyone gets the live build.
// ============================================================================
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister().then((ok) => {
        if (ok) console.log('[SW] Unregistered stale service worker');
      });
    }
  }).catch(() => {});

  if (window.caches && typeof caches.keys === 'function') {
    caches.keys().then((keys) => {
      keys.forEach((key) => caches.delete(key));
    }).catch(() => {});
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);